import { useMutation } from '@hooks/useJarvisMutation';
import { endPoints } from '@routes';

export type InquiryTarget = 'sales' | 'support';

type Input = {
  email: string;
  body: {
    name: string;
    email: string;
    subject: `CDN77.com - ${string}`;
    message: string;
    estimated_traffic?: string;
    project?: string;
    utm: Record<string, unknown>;
    formUrl: string;
  };
  wherefrom: `Contact - ${InquiryTarget}`;
  department: InquiryTarget;
};

export const useSendInquiryMutation = () => {
  const mutation = useMutation<undefined, Input>(endPoints.sendInquiry, {});

  return mutation;
};
